import React, { useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Panel } from '@bingads-webui-react/primitive';

import { ChevronIcon } from './chevron-icon';
import { getFaqAccordionStyles } from './styles/get-faq-accordion-styles';

export function FAQAccordion(props) {
  const {
    title,
    content,
    logger,
  } = props;
  const [isOpen, setOpen] = useState(false);
  const classes = useDefaultStyles(getFaqAccordionStyles);
  const i18n = useContext(I18nContext);

  const onClickToggle = useCallback(() => {
    logger.trace(`new Status: ${!isOpen}; faqTitle: ${title}; faqContent: ${content}`);
    setOpen(current => !current);
  }, [content, isOpen, title, logger]);

  return (
    <div className={classNames('faq-accordion-container', classes.faqAccordionContainer)}>
      <button
        className={classNames('faq-panel-title', classes.faqPanelTitle)}
        onClick={onClickToggle}
      >
        <div className={classNames('faq-panel-title-text', isOpen ? classes.faqPanelTitleTextOpen : classes.faqPanelTitleTextClose)}>
          {i18n.getString(title)}
        </div>
        <div className={classNames('faq-panel-title-icon', isOpen ? classes.faqPanelTitleIconOpen : classes.faqPanelTitleIconClose)}>
          <ChevronIcon />
        </div>
      </button>
      <Panel className={classNames('faq-panel', classes.faqPanel)} expanded={isOpen}>
        <Panel.Collapse>
          <Panel.Body>
            {i18n.getString(content)}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    </div>
  );
}

FAQAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  logger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }).isRequired,
};
